import * as React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { TransitionProps } from '@mui/material/transitions';
import { AppBar, Avatar, CircularProgress, Dialog, Grid, Slide, Tab, Tabs, Toolbar, Divider, Tooltip, LinearProgress, LinearProgressProps } from '@mui/material';
import { IconButton } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import { Box } from '@mui/material';
import { Alert } from '@mui/material';
import ErrorBoundary from '../../Common/ErrorBoundary';
import { DataGrid, GridActionsCellItem, GridRowId, GridRowModes } from '@mui/x-data-grid';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import ErrorIcon from '@mui/icons-material/ErrorOutline';

function LinearProgressWithLabel(props: LinearProgressProps & { item: number, total: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '90%', mr: 1 }}>
        <LinearProgress variant="determinate" value={props.item / props.total * 100} />
      </Box>
      <Box sx={{ minWidth: 75 }}>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary' }}
        >{` ${props.item} / ${props.total} - ${Math.round(props.item / props.total * 100)}% completed `}</Typography>
      </Box>
    </Box>
  );
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
  };
}

export default function AdminDialog(props: {
  open: boolean;
  manage: boolean;
  user?: {name: string, id: number} | null;
  onClose: () => void;
  title?: string;
  fileContent?: string[];
  handleRemoveUser?: (index: number) => void;
}) {
  const [loading, setLoading] = React.useState(false);
  const [completed, setCompleted] = React.useState(false);
  const [processing, setProcessing] = React.useState(false);
  const [profile, setProfile] = React.useState<object | null>(null);
  // const [permissions, setPermissions] = React.useState<object | null>([]);
  const [customers, setCustomers] = React.useState<string[] | null>([]);
  const [rowModesModel, setRowModesModel] = React.useState<any>({});
  const [tab, setTab] = React.useState<number>(0);
  const [usersTab, setUsersTab] = React.useState<string>('A');
  const [rows, setRows] = React.useState<any[]>([]);
  const [invalidEmails, setInvalidEmails] = React.useState<any[]>([]);
  const [invalidPhones, setInvalidPhones] = React.useState<any[]>([]);
  const [progress, setProgress] = React.useState<number>(0);
  const [total, setTotal] = React.useState<number>(0);
  // const [taskId, setTaskId] = React.useState<string | null>(null);

  const handleChangeUsersTab = (event: React.SyntheticEvent, newValue: string) => {
    setUsersTab(newValue);
    if (newValue === 'E') {
      setInvalidEmails(rows?.filter((row: any) => !row.email));
    } else if (newValue === 'P') {
      setInvalidPhones(rows?.filter((row: any) => !row.phone));
    } else {
      setInvalidEmails([]);
      setInvalidPhones([]);
      setRows(rows);
    }
  };

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

//   const startCreation = async () => {
//     setCompleted(false);
//     setProgress(0);
//     const csrfToken = await axios.get('/csrf/')
//     const response = await axios.post(`/api/create-objects/`, {
//       total_objects: rows.length,
//     }, {
//       headers: {
//         'Content-Type': 'application/json',
//         'X-CSRFToken': csrfToken.data.csrfToken,
//       },
//     });
//     setTaskId(response.data.task_id);
//     if (!taskId) {return;}
//     const interval = setInterval(async () => {
//       const response = await axios.get(`/celery-progress/task_status/${taskId}/`);
//       const data = response.data; // { progress: { percent: ..., current: ..., total: ... }, state: ... }
  
//       if (data.state === 'SUCCESS' || data.state === 'FAILURE') {
//         clearInterval(interval);
//         // Handle completion or error
//       } else {
//         // Update local state with the percentage
//         setProgress(data.progress.percent);
//       }
//     }, 1000); 
// };
  
  const startProcessing = async (manage: boolean) => {
    setLoading(true);
    setCompleted(false);
    setProcessing(true);
    const users = props.fileContent;
    const csrfToken = await axios.get('/csrf/')
    if (manage) {
      setTotal(rows.length); 
      await axios.post(`/admin/users/create-massive/?entity_id=${localStorage.getItem('entity_id')}`, {
        data: rows,
      }, {
        headers: {
          'X-CSRFToken': csrfToken.data.csrfToken,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        setProgress((prevProgress) => prevProgress + 1);
        if (response.data.message) {
          console.log(response.data);
          // setRows((prevRows) => prevRows.map((prevRow) => (prevRow.id === row.id ? { ...prevRow, id: response.data.user_id } : prevRow)));
        } else {
          toast.error(response.data.error, {position: 'top-center'});
        }
      }).catch((error) => {
        toast.error(error.response?.data?.message, {position: 'top-center'});
      });
      
    }else{
      users.forEach(async (user: string) => {
        const interval = setInterval(async () => {
          setProcessing(true);
          await axios.post('/admin/user/deactivate/', {
            user: user,
          }, {
            headers: {
              'X-CSRFToken': csrfToken.data.csrfToken,
              'Content-Type': 'application/json',
            },
          }).then(() => {
            setProcessing(false);
          });
        }, 1000);
      })
    }
    setCompleted(true);
    setProcessing(false);
    setLoading(false);
  };

  React.useEffect(() => {
    if (props.open) {
      setLoading(true);
      if (!props.manage) {
        axios.get(`/admin/users/${props.user?.id}/view/?entity_id=${localStorage.getItem('entity_id')}`).then((response) => {
          setProfile(response.data['profile']);
          // setPermissions(response.data['profile']['permissions']);
          setCustomers(response.data['profile']['customers']);
        }).catch((error) => {
          toast.error('Failed to load user profile. Please try again or contact with the administrator.');
        }).finally(() => {
          setLoading(false);
        });
      }else{
        setProcessing(true);
        setInvalidEmails(props.fileContent?.filter((line: any) => !line.email));
        setInvalidPhones(props.fileContent?.filter((line: any) => !line.phone));
        setRows(props.fileContent?.length > 0 ? props.fileContent?.map((line: any, index: number) => ({
          id: index + 1,
          ...line as object,
        })) : []);
      }
      // setCompleted(true);
      setLoading(false);
      setProcessing(false);
    }
  }, [props.open, props.fileContent]);

  const handleRemoveFromList = (id: GridRowId) => {
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));
    setInvalidEmails((prevInvalidEmails) => prevInvalidEmails.filter((row) => row.id !== id));
    setInvalidPhones((prevInvalidPhones) => prevInvalidPhones.filter((row) => row.id !== id));
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={props.open}
        onClose={props.onClose}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {props.title || ''}
            </Typography>
            {props.manage && 
              <Button 
                autoFocus 
                color="success" 
                variant="contained" 
                style={{textTransform: 'none', boxShadow: 'none', border: 'none'}} 
                onClick={() => startProcessing(props.manage)} 
                loading={loading} 
                loadingPosition='start'
                disabled={rows.length === 0 || rows.filter((row) => !row.email || !row.phone).length > 0}
              >
                Start Processing
              </Button>
            }
            <Button autoFocus color="inherit" onClick={props.onClose} style={{textTransform: 'none'}}>Close</Button>
          </Toolbar>
        </AppBar>
        <Box sx={{ p: 2, backgroundColor: 'inherit' }}>
          {props.manage ? (
            <ErrorBoundary>
              <Box sx={{width: '100%', margin: 'auto', maxWidth: '90%', borderRadius: '10px'}}>
                {rows.filter((row) => !row.email || !row.phone).length > 0 && <Alert severity="error" style={{marginBottom: 10}}>There are invalid items in the list. Please fix them before starting the processing.</Alert>}
                {loading && <Alert severity="error" style={{marginBottom: 10}}><b>DO NOT CLOSE</b> the dialog window until the processing is complete.</Alert>} 
                {completed && <Alert severity="success" style={{marginBottom: 10}}>Processing completed</Alert>}
                {/* {props.children} */}
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  {props.manage && processing && !completed && <LinearProgressWithLabel item={progress} total={total} />}
                  <TabContext value={usersTab}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <Tabs value={usersTab} onChange={handleChangeUsersTab} aria-label="users processing tabs" centered>
                        <Tab label={`All (${Intl.NumberFormat('en-US').format(rows.length)})`} value="A" />
                        <Tab label={`Invalid Emails (${Intl.NumberFormat('en-US').format(rows.filter((row) => !row.email).length)})`} value="E" />
                        <Tab label={`Invalid Phones (${Intl.NumberFormat('en-US').format(rows.filter((row) => !row.phone).length)})`} value="P" />
                      </Tabs>
                    </Box>
                    <TabPanel value={usersTab}>
                      <DataGrid
                        editMode="row"
                        rowModesModel={rowModesModel}
                        onRowModesModelChange={setRowModesModel}
                        rows={usersTab === 'A' ? rows : usersTab === 'E' ? invalidEmails : invalidPhones}
                        columns={[
                          { field: 'id', headerName: 'ID', width: 60, editable: false, headerAlign: 'center', align: 'center' }, 
                          { field: 'name', headerName: 'Name', width: 300, headerAlign: 'center', align: 'center', renderCell: (params) => {
                            return (
                              <span style={{justifyContent: 'center', alignItems: 'center'}}>
                                {params.row.error === 'name' ? 
                                  <Tooltip title="Name is missing"><ErrorIcon color="error" fontSize="small" style={{margin: 'auto'}} /></Tooltip>
                                 : <span>{params.row.name}</span>}
                              </span>
                            );
                          }},
                          { field: 'phone', headerName: 'Phone', width: 200, headerAlign: 'center', align: 'center', renderCell: (params) => {
                            return (
                              <span style={{justifyContent: 'center', alignItems: 'center'}}>
                                {params.row.error === 'phone' ? 
                                  <Tooltip title="Phone number is missing or already exists"><ErrorIcon color="error" fontSize="small" style={{margin: 'auto'}} /></Tooltip>
                                 : <span>{params.row.phone}</span>}
                              </span>
                            );
                          }},
                          { field: 'email', headerName: 'Email', width: 200, headerAlign: 'center', align: 'center', renderCell: (params) => {
                            return (
                              <span style={{justifyContent: 'center', alignItems: 'center'}}>
                                {params.row.error === 'email' ? 
                                  <Tooltip title="Email address is missing or already exists"><ErrorIcon color="error" fontSize="small" style={{margin: 'auto'}} /></Tooltip>
                                 : <span>{params.row.email}</span>}
                              </span>
                            );
                          }},
                          { field: 'role', headerName: 'Role', width: 100, headerAlign: 'center', align: 'center', renderCell: (params) => {
                            return (
                              <span style={{justifyContent: 'center', alignItems: 'center'}}>
                                {params.row.error === 'role' ? 
                                  <Tooltip title="Role is missing"><ErrorIcon color="error" fontSize="small" style={{margin: 'auto'}} /></Tooltip>
                                 : <span>{params.row.role}</span>}
                              </span>
                            );
                          }},
                          { field: 'actions', headerName: 'Actions', width: 100, type: 'actions', editable: false, headerAlign: 'center', align: 'center',
                            getActions: ({ row, id }) => {
                              const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
                              const user = {name: row.name, id: row.id};
                              
                              if (isInEditMode) {
                                return [
                                  <GridActionsCellItem
                                    icon={<Tooltip title="Save"><SaveIcon /></Tooltip>}
                                    label="Save"
                                    material={{
                                      sx: {
                                        color: 'primary.main',
                                      },
                                    }}
                                  />,
                                  <GridActionsCellItem
                                    icon={<Tooltip title="Cancel"><CancelIcon /></Tooltip>}
                                    label="Cancel"
                                    className="textPrimary"
                                    color="inherit"
                                  />,
                                ];
                              }
                      
                              return [
                                <GridActionsCellItem
                                  icon={<Tooltip title="Edit"><EditIcon /></Tooltip>}
                                  label="Edit"
                                  className="textPrimary"
                                  color="inherit"
                                />,
                                <GridActionsCellItem
                                  icon={<Tooltip title="Remove from the list"><CloseIcon /></Tooltip>}
                                  label="Remove from the list"
                                  className="textPrimary"
                                  color="inherit"
                                  onClick={() => handleRemoveFromList(user.id)}
                                />,
                              ];
                            },  
                          }
                        ]}
                        initialState={{
                          pagination: { paginationModel: { pageSize: 10 } },
                        }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        showToolbar
                        loading={loading}
                      />
                    </TabPanel>
                  </TabContext>
                </Box>
                <ToastContainer position='top-center'/>
              </Box>
            </ErrorBoundary>
          ) : (
            <ErrorBoundary>
              <Box sx={{width: '100%', margin: 'auto', maxWidth: '100%', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto'}}>
                {loading && 
                  <>
                    <span style={{fontSize: '10rem !important', fontWeight: 'bold', marginBottom: 20, textAlign: 'center'}}>{props.user ? `Loading user's ${props.user.name} profile...` : 'Loading profile...'}</span>
                    <CircularProgress size={window.innerWidth / 10} sx={{color: 'primary.main'}} />
                  </>
                }
              </Box>
              {!loading && (
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
                  <Tabs 
                    value={tab} 
                    onChange={handleChangeTab} 
                    centered 
                    aria-label="user profile tabs"
                    sx={{width: '100%', margin: 0.25, padding: 0}}
                  >
                    <Tab label="Overview" style={{textTransform: 'capitalize'}} value={0}/>
                    {/* <Tab label="Permissions" style={{textTransform: 'capitalize'}} value={1}/> */}
                    <Tab label={`Customers ${customers?.length > 0 ? `(${Intl.NumberFormat('en-US').format(customers?.length)})` : ''}`} style={{textTransform: 'capitalize'}} value={1}/>
                  </Tabs>
                  {tab === 0 && (
                    <Box sx={{width: '100%', margin: '10px auto', maxWidth: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto'}}>
                      {profile && (
                        <Box sx={{ padding: 2, backgroundColor: localStorage.getItem('theme') === 'light' ? 'white' : '#192841', width: '100%', margin: 'auto', maxWidth: 600, borderRadius: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
                          <Grid container spacing={2} sx={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3, xl: 3 }}>
                              <Avatar 
                                variant="rounded"
                                alt={profile['name'] || ''}
                                {...stringAvatar(profile['name'] || '')}
                                sx={{ width: window.innerWidth / 15, height: window.innerWidth / 15, margin: 'auto' }} 
                              />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 9, xl: 9 }}>
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginBottom: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Name:</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['name']}</Typography>
                              </Typography>
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginBottom: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Email:</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['email']}</Typography>
                              </Typography>
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginBottom: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Phone:</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['phone']}</Typography>
                              </Typography>
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginBottom: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Role:</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['role']}</Typography>
                              </Typography>
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginBottom: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Status:</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['active_ind'] == 1 ? 'Active' : 'Inactive'}</Typography>
                              </Typography>
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginBottom: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Manufacturer(s):</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['entities'].join(', ')}</Typography>
                              </Typography>
                              <Divider />
                              <Typography variant="body2" component="div" sx={{textAlign: 'left', marginTop: 1, width: '100%'}}>
                                <Typography variant="body2" component="span" color="text.secondary">Created At:</Typography> <Typography variant="body2" component="span" style={{float: 'right'}}>{profile['created_at']}</Typography>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                    </Box>
                  )}
                  {/* {tab === 1 && (
                    <Box sx={{width: '100%', margin: 'auto', maxWidth: '100%', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto'}}>
                      <Typography variant="h6">Permissions</Typography>
                    </Box>
                  )} */}
                  {tab === 1 && (
                    <Box sx={{width: '100%', margin: 'auto', maxWidth: '100%', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: 'auto'}}>
                      {
                        customers && customers.length > 0 ? (
                          <div style={{ height: 600, width: '80%', margin: 'auto' }}>
                            <DataGrid
                              rows={customers.map((customer: string, idx: number) => ({
                                id: idx + 1,
                                name: customer,
                              }))}
                              columns={[
                                { field: 'id', headerName: 'ID', width: 100 },
                                { field: 'name', headerName: 'Name', width: 300 },
                              ]}
                              initialState={{
                                pagination: { paginationModel: { pageSize: 10 } },
                              }}
                              slotProps={{
                                toolbar: {
                                  showQuickFilter: true,
                                  quickFilterProps: { debounceMs: 500 }
                                },
                              }}
                              pageSizeOptions={[10, 20, 50, 100]}
                              showToolbar
                            />
                          </div>
                        ) : (
                          <Typography variant="body2" component="div" sx={{textAlign: 'center', marginBottom: 1, width: '100%'}}>
                            No customers assigned to this user.
                          </Typography>
                        )
                      }
                    </Box>
                  )}
                </Box>
              )}
            </ErrorBoundary>
          )}
        </Box>
        <ToastContainer position='top-center'/>
      </Dialog>
    </React.Fragment>
  );
}
